import React from 'react'
import logUtil from 'utils/log'
import useSelector from 'hooks/use-selector'
import getCurrentIdProductSelect from 'modules/product/redux/selectors/get-current-id'
import useDispatch from 'hooks/use-dispatch'
import getByIdProductSelector from 'modules/product/redux/selectors/get-by-id'
import updateCurrentProductIdAction from 'modules/product/redux/actions/update-current'
import updateCurrentVariantIdAction from 'modules/variant/redux/actions/update-current'
import MediaGallery from 'components/MediaGallery'
import H3 from 'components/H3'
import FlexColumn from 'components/FlexColumn'
import Span from 'components/Span'
import PageLoader from 'components/PageLoader'
import QuickShopProductSidebarLikes from 'containers/QuickShopProductSidebar/components/Likes'
import QuickShopProductSidebarReviewRating from 'containers/QuickShopProductSidebar/components/ReviewRating'
import QuickShopProductSidebarShortDescription from 'containers/QuickShopProductSidebar/components/ShortDescription'
import QuickShopProductSidebarHowToUse from 'containers/QuickShopProductSidebar/components/HowToUse'
import QuickShopProductSidebarIngredients from 'containers/QuickShopProductSidebar/components/Ingredients'
import QuickShopProductSidebarColorSwatches from 'containers/QuickShopProductSidebar/components/ColorSwatches'
import QuickShopProductSidebarAboutThisItem from 'containers/QuickShopProductSidebar/components/AboutThisItem'
import QuickShopProductSidebarSizeGuide from 'containers/QuickShopProductSidebar/components/SizeGuide'
import getVariantsProductVariantUtil from 'modules/product-variant/utils/get-variants'
import isSelfGiftingUrlLocationUtil from 'utils/location/is-self-gifting-url'
import {
  GIFT_CARD_PRODUCT_DESCRIPTION,
  GIFT_CARD_PRODUCT_VARIANT
} from 'modules/gift/constants'
import GiftPageAddAGiftAmountPicker from 'pages/Gift/components/AddAGiftCard/components/AmountPicker'
import P from 'components/P'
import shouldFlattenSamplesUrlLocationUtil from 'utils/location/should-flatten-samples'
import createDefaultMediaProductUtil from 'modules/product/utils/create-default-media'
import getCurrentVariantProductSelect from 'modules/product/redux/selectors/get-current-variant'
import View from 'components/View'
import ProductCardLoyaltyTierIcon from 'components/ProductCardLoyaltyTierIcon'
import getLoyaltyTierNameProductVariantUtil from 'modules/gift/utils/get-loyalty-tier-name'
import ProductBadges from 'components/ProductBadges'
import Highlights from 'containers/QuickShopProductSidebar/Highlights'
import getProductIdFromUrlProductUtil from 'modules/product/utils/get-product-id-from-url'
import getVariantIdFromUrlProductUtil from 'modules/product/utils/get-variant-id-from-url'

import QuickShopProductSidebarSquadApprovedBadge from 'containers/QuickShopProductSidebar/components/QuickShopProductSidebarSquadApprovedBadge'
import Reviews from 'containers/QuickShopProductSidebar/components/Reviews/index.js'
import getDiscountDataSelectorProductCollectionItemSelector from 'containers/ProductCollection/components/Item/redux/selectors/get-discount-data'
import isDeluxeSampleOptionUtil from 'modules/variant/utils/is-deluxe-sample-option'
import VariantButtons from 'containers/QuickShopProductSidebar/components/VariantButtons'
import updateIsSampleVariantIdAction from 'modules/variant/redux/actions/update-is-sample'
import isSampleVariantSelect from 'modules/product/redux/selectors/is-sample'
import updateFullSizeVariant from 'modules/variant/redux/actions/update-full-size-variant'
// import RelatedProducts from 'containers/QuickShopProductSidebar/components/RelatedProducts'
import QuickShopProductSidebarDelivery from 'containers/QuickShopProductSidebar/components/Delivery'
import PriceAndDiscountPrice from 'components/PriceAndDiscountPrice'
import hasSubscriptionsVariantProductSelector from 'modules/product/redux/selectors/has-subscriptions'
// import openQuickShopProductSidebarGiftAction from 'modules/product/redux/actions/open-quick-shop-product-sidebar'
import getCurrentDataSidebarSelect from 'modules/sidebar/redux/selectors/get-current-data'
import getPriceProductVariantUtil from 'modules/product-variant/utils/get-price'
import getSelectedColorVariantIdVariantSelect from 'modules/variant/redux/selectors/get-selected-color-variant-id'
import updateQuickShopHistoryProductsAction from 'modules/product/redux/actions/update-quick-shop-history'
import getQuickShopHistoryProductsSelect from 'modules/product/redux/selectors/get-quick-shop-history'
import updateSelectedColorOptionAction from 'modules/variant/redux/actions/update-selected-color-option'
import QuickShopProductSidebarLoad from 'containers/QuickShopProductSidebar/Load'
import getDiscountPercentageVariantSelector from 'modules/variant/redux/selectors/get-discount-percentage'
import QuickShopProductSidebarLogConversionEvent from 'containers/QuickShopProductSidebar/LogConversionEvent'
import updateShouldUpdateMediaAction from 'modules/media-gallery/redux/actions/update-should-update-media'
import QuickShopHandleHistoryMediaIndexUpdate from 'containers/QuickShopProductSidebar/HandleHistoryMediaIndexUpdate'

import isMiniStrProductUtil from 'containers/QuickShopProductSidebar/utils/is-mini-product/index.js'
import QuickShopProductSidebarInfluencerCard from 'containers/QuickShopProductSidebar/components/InfluencerCard'
import isInfluencerEnabledAppUtil from 'modules/app/utils/is-influencer-enabled'
import getSelectedVariantSelect from 'modules/variant/redux/selectors/get-selected-variant'
import QuickShopProductSidebarUseItWith from 'containers/QuickShopProductSidebar/components/UseItWith'
import QuickShopProductSidebarLogUserDataConversionEvent from 'containers/QuickShopProductSidebar/LogUserDataConversionEvent'
import QuickShopProductSidebarSuggestInStockVariantOnMount from 'containers/QuickShopProductSidebar/components/SuggestInStockVariantOnMount'
import loadAndUpdateProductAndVariantIdFromUrlQuickShopAction from 'containers/QuickShopProductSidebar/actions/update-product-and-variant-id-from-url'
import isPaidSingleUseOptionUtil from 'modules/variant/utils/is-paid-single-use-option'

import QuickShopProductSidebarEditRating from 'containers/QuickShopProductSidebar/components/EditRating'
import shouldShowEditRatingSelector from 'modules/variant/redux/selectors/should-show-edit-rating'
import needsToBeRatedSampleSelector from 'modules/variant/redux/selectors/needs-to-be-rated-sample'

import QuickShopLoadRatedVariant from 'containers/QuickShopProductSidebar/QuickShopLoadRatedVariant'
import isGiftSetVariantUtil from 'modules/variant/utils/is-gift-set'

import getIdFromRatedSampleOrProductVariantSelector from 'containers/QuickShopProductSidebar/selector/get-Id-from-rated-sample-or-product-variant'

import FullSizeDiscountAlert from 'containers/QuickShopProductSidebar/components/FullSizeDiscountAlert'
import DescriptionBenefits from 'pages/Product/containers/Description/components/Benefits'

import ProductDeliveryStatus from 'pages/Product/containers/DeliveryStatus'
import QuickShopProductSidebarButton from 'containers/QuickShopProductSidebar/components/Button'
import OtherItemsYourSquadLoved from 'containers/QuickShopProductSidebar/components/OtherItemsYourSquadLoved'
import FullSizeItemsYouVeSampled from 'containers/QuickShopProductSidebar/components/FullSizeYouVeAlreadySampled'
import CustomersAlsoBoughtSlider from 'containers/QuickShopProductSidebar/components/CustomersAlsoBoughtSlider'
import ProductDescriptionPageBreadcrumb from 'pages/Product/containers/Description/components/Breadcrumb'
import shouldShowBannerPostSampleSurveySelect from 'modules/post-sample-survey/redux/selectors/should-show-banner'

import CartBottomBar from 'containers/CartBottomBar'
import setTitleDomUtil from 'utils/dom/set-title'
import './index.css'
import classNames from 'classnames'

import shouldShowFastTrackExpiryBannerLoyaltySelect from 'modules/loyalty/redux/selectors/should-show-fast-track-expiry-banner'
import isCurrentVariantAFullSizeProductSelect from 'modules/gift/redux/selectors/is-current-variant-a-full-size'
import shouldShowYouVeUnlockedPercentageOffAtCheckoutBannerSelect from 'containers/YouVeUnlockedPercentageOffAtCheckoutBanner/selectors/should-show'
import QuickShopProductSidebarHandleHistory from 'containers/QuickShopProductSidebar/HandleHistory'
import ProductPageHandlePopState from 'pages/Product/containers/HandlePopState'
import ProductPageHandleIsNavigating from 'pages/Product/containers/HandleIsNavigating'
import updateIsFromSelfGiftingGiftUtil from 'modules/gift/utils/update-is-from-self-gifting'
import DealTimer from 'containers/Deals/components/DealTimer'
import shouldShowDealTimerProductSelector from 'containers/Deals/selector/should-show-deal-timer-product'
import ProductAOVLockIcon from 'components/ProductAOVLockIcon'
import { shouldShowAOVLockProductVariantSelector } from 'modules/product-variant/redux/selectors/should-show-aov-lock'
import { shouldShowAOVUnlockProductVariantSelector } from 'modules/product-variant/redux/selectors/should-show-aov-unlock'
import ProductAOVUnlockIcon from 'components/ProductAOVUnlockIcon'

const ANALYTIC_EVENT_PREFIX = 'QUICK_SHOP'

/**
 * @param props
 * @return {JSX.Element}
 * @constructor
 */
export default function ProductDescriptionContentPage (props) {
  const dispatch = useDispatch()
  const productId = useSelector(getCurrentIdProductSelect)
  /**
   * @type {ProductVariantCollection}
   */
  const productVariant = useSelector(getCurrentVariantProductSelect)
  /**
   * @type {ProductVariantCollection}
   */
  const selectedProductVariant = useSelector(getSelectedVariantSelect)
  const productIdFromUrl = getProductIdFromUrlProductUtil()
  const variantIdFromUrl = getVariantIdFromUrlProductUtil()
  const variants = getVariantsProductVariantUtil(productVariant)
  const shouldShowPostSampleSurveyBanner = useSelector(shouldShowBannerPostSampleSurveySelect)

  const variantIdToShowTimer = Number(variantIdFromUrl) ?? productVariant?.variant_id

  const shouldShowDealTimer = useSelector(shouldShowDealTimerProductSelector(variantIdToShowTimer))
  /**
   * @type {QuickShopSidebarData}
   */
  const sidebarData = useSelector(getCurrentDataSidebarSelect)

  const ratedVariantId = sidebarData?.selectedVariantId

  const isFullSize = useSelector(isCurrentVariantAFullSizeProductSelect)
  const isSelfGifting = isSelfGiftingUrlLocationUtil()
  const hasSampleVariants = !!variants?.length
  const shouldFlattenSamples = shouldFlattenSamplesUrlLocationUtil()
  /**
   * @type {ProductFrontend}
   */
  const product = useSelector(getByIdProductSelector(productId))
  const shortDescription = productVariant?.short_description
  const howToUse = productVariant?.how_to_use
  const ingredients = productVariant?.ingredients
  let imageUrl = shouldFlattenSamples
    ? productVariant?.variant_image_url
    : productVariant?.image_url
  if (shouldFlattenSamples && !imageUrl) {
    imageUrl = productVariant?.image_url
  }
  const defaultFirstMedia = createDefaultMediaProductUtil({ imageUrl })
  const defaultMedia = imageUrl
    ? [defaultFirstMedia]
    : null

  const productImagesMedia = product?.images?.map(image => ({
    id: image.id,
    image: { url: image.src },
    previewImage: { url: image.src },
    mediaContentType: 'IMAGE'
  }))

  const media = productVariant?.media || productImagesMedia || defaultMedia
  const aboutImageUrl = productVariant?.about_image_url
  const bodyHtml = product?.body_html
  const productFavStats = productVariant?.product_fav_stats
  const likedCount = productFavStats?.liked_count
  const superLikedCount = productFavStats?.super_liked_count
  const hasLikes = !!(likedCount || superLikedCount)
  const isGiftCard = productVariant?.variant_id === GIFT_CARD_PRODUCT_VARIANT.variant_id
  const price = getPriceProductVariantUtil(selectedProductVariant)
  const discountPercentage = useSelector(
    getDiscountPercentageVariantSelector({
      variantId: productVariant?.variant_id,
      shouldDebug: true
    })
  )
  const highlights = productVariant?.highlights
  const hasSubscriptions = useSelector(
    hasSubscriptionsVariantProductSelector(productVariant?.variant_id)
  )
  const selectedVariantId = useSelector(getSelectedColorVariantIdVariantSelect)
  const isSampleVariant = useSelector(isSampleVariantSelect)
  const isSample = (
    !isFullSize && (
      isSampleVariant ||
      sidebarData?.isSample
    )
  )
  const productVariants = product?.variants
  const quickShopHistory = useSelector(getQuickShopHistoryProductsSelect) || []
  // const hideBothFullSizeAndSampleButtons = useSelector(shouldHideVariantButtonsSelector)

  const shouldShowYouVeUnlockedPercentageOffAtCheckoutBanner = useSelector(shouldShowYouVeUnlockedPercentageOffAtCheckoutBannerSelect)

  const isMini = isMiniStrProductUtil(productVariant?.title)

  const [isLoading, setIsLoading] = React.useState(true)

  const {
    isOnlyAtAirshopDiscount,
    discountPrice,
    discountPercentage: discountPercentageToPass
  } = useSelector(
    getDiscountDataSelectorProductCollectionItemSelector({
      discountPercentage,
      isFullSize,
      price,
      productVariant,
      discountPrice: sidebarData?.discountPrice,
      shouldStackSubscriptionDiscount: true,
      variantId: selectedVariantId,
      debug: true
    })
  )

  const productLoyaltyTierName = getLoyaltyTierNameProductVariantUtil(productVariant)
  const hasDeluxeSample = isDeluxeSampleOptionUtil(productVariant?.size_option)
  const showDeluxeBanner = hasDeluxeSample && !isFullSize
  const hasPaidSingleUseSample = isPaidSingleUseOptionUtil(productVariant?.size_option)
  const showPaidSingleUseBanner = hasPaidSingleUseSample && !isFullSize
  const wasJustDropped = productVariant?.just_dropped
  const ratedSampleOrProductVariantId = useSelector(getIdFromRatedSampleOrProductVariantSelector({ selectedProductVariant }))
  const shouldShowEditRating = useSelector(shouldShowEditRatingSelector(ratedSampleOrProductVariantId))
  const needsToBeRatedSample = useSelector(needsToBeRatedSampleSelector(ratedSampleOrProductVariantId))
  const shouldShowFastTrackExpiryBanner = useSelector(shouldShowFastTrackExpiryBannerLoyaltySelect)
  const aovLock = productVariant?.aov_lock
  const shouldShowAovLock = useSelector(shouldShowAOVLockProductVariantSelector({ productVariant }))
  const shouldShowAovUnlock = useSelector(shouldShowAOVUnlockProductVariantSelector({ productVariant }))

  const shouldRemoveMediaPadding =
    shouldShowYouVeUnlockedPercentageOffAtCheckoutBanner ||
    shouldShowPostSampleSurveyBanner ||
    shouldShowFastTrackExpiryBanner

  const debugProps = {
    sidebarData,
    props,
    productId,
    product,
    productVariant,
    selectedProductVariant,
    isSelfGifting,
    isFullSize,
    shouldFlattenSamples,
    media,
    discountPercentage,
    discountPrice,
    isOnlyAtAirshopDiscount,
    hasDeluxeSample,
    showDeluxeBanner,
    showPaidSingleUseBanner,
    productIdFromUrl,
    variantIdFromUrl,
    productVariants,
    isSample,
    hasSubscriptions,
    quickShopHistory,
    isMini,
    shouldShowEditRating
  }

  logUtil('ProductDescriptionContentPage').debug('debugProps=', debugProps)

  const updateProductAndVariantIdFromUrl = async () => {
    logUtil('ProductDescriptionContentPage#updateProductAndVariantIdFromUrl').debug('[start]')
    dispatch(
      loadAndUpdateProductAndVariantIdFromUrlQuickShopAction({
        productVariant,
        variantIdFromUrl,
        productIdFromUrl,
        isFullSize,
        isSample
      })
    )
  }

  const handleMount = () => {
    updateProductAndVariantIdFromUrl()
    logUtil('ProductDescriptionContentPage#handleMount').debug('[start]')
  }

  React.useEffect(() => {
    updateProductAndVariantIdFromUrl()
  }, [
    variantIdFromUrl
  ])

  React.useEffect(() => {
    if (shouldShowYouVeUnlockedPercentageOffAtCheckoutBanner) {
      updateIsFromSelfGiftingGiftUtil(true)
    }
  }, [
    shouldShowYouVeUnlockedPercentageOffAtCheckoutBanner
  ])

  const handleUpdateTitle = async () => {
    if (productVariant) {
      setTitleDomUtil(productVariant?.title)
      // await runAfterDelayTimingUtil(2000)
      // removeHashLocationUtil()
    }
  }

  React.useEffect(() => {
    handleUpdateTitle()
  }, [
    productVariant
  ])

  const handleUnmount = () => {
    dispatch(updateShouldUpdateMediaAction(true))
    dispatch(updateFullSizeVariant())
    dispatch(updateCurrentProductIdAction())
    dispatch(updateCurrentVariantIdAction())
    dispatch(updateIsSampleVariantIdAction())
    dispatch(updateQuickShopHistoryProductsAction([]))
    dispatch(updateSelectedColorOptionAction({ selectedOption: null }))
  }

  React.useEffect(() => {
    handleMount()
    return handleUnmount
  }, [])

  const influencerInfo = selectedProductVariant?.influencer_info
  const hasInfluencerInfo = (
    isInfluencerEnabledAppUtil() &&
    !!influencerInfo
  )

  const perfectYourLookVariantId = selectedProductVariant?.pyl_variant_id
  const hasUseItWithVariant = (
    isInfluencerEnabledAppUtil() &&
    !!perfectYourLookVariantId
  )

  if (!productVariant) {
    return <PageLoader />
  }

  const hasVariantButtons = (
    !!productVariants?.length &&
    !sidebarData?.shouldHideVariantButtons
  )

  return (
    <FlexColumn
      className={classNames({
        'product-description-page-container': true,
        'pdp-reset-padding': shouldRemoveMediaPadding,
        'pdp-reset-margin': shouldShowPostSampleSurveyBanner
      })}
    >
      <QuickShopProductSidebarHandleHistory />
      <ProductPageHandlePopState />
      <ProductPageHandleIsNavigating />
      <ProductDescriptionPageBreadcrumb
        productVariant={productVariant}
      />
      <QuickShopProductSidebarLogUserDataConversionEvent />
      <QuickShopHandleHistoryMediaIndexUpdate />
      <CartBottomBar />
      <QuickShopProductSidebarLoad
        productVariant={productVariant}
        productId={productId}
        shouldFlattenSamples={shouldFlattenSamples}
        hasSampleVariants={hasSampleVariants}
      />

      <QuickShopProductSidebarLogConversionEvent
        productVariant={productVariant}
        price={price}
        product={product}
        discountPrice={discountPrice}
        variantIdFromUrl={variantIdFromUrl}
      />

      {
        (!product || isLoading) && (
          <PageLoader />
        )
      }

      {
        !!product &&
        !isLoading && (
          <FlexColumn className='pdp-main-content'>
            <>
              {
                !!productLoyaltyTierName && (
                  <View>
                    <ProductCardLoyaltyTierIcon
                      tierName={productLoyaltyTierName}
                      isLight
                    />
                  </View>
                )
              }

              {
                !!shouldShowAovLock && (
                  <ProductAOVLockIcon
                    aovLock={aovLock}
                  />
                )
              }

              {
                !!shouldShowAovUnlock && (
                  <ProductAOVUnlockIcon
                    aovLock={aovLock}
                  />
                )
              }

              <div className='pdp-media-gallery-and-content-wrapper'>
                <div className='pdp-media-gallery-wrapper'>
                  {
                    !!media && (
                      <MediaGallery
                        media={media}
                        shouldSwipe
                        hasPicker={!isGiftCard}
                        showDeluxeBanner={showDeluxeBanner}
                        showPaidSingleUseBanner={showPaidSingleUseBanner}
                        isFromProductPage
                      />
                    )
                  }
                </div>

                <div className='pdp-product-description-wrapper'>
                  <H3 className='pdp-product-title'>
                    {productVariant?.title}
                  </H3>

                  <ProductBadges
                    isTrending={productVariant?.trending}
                    isViralOnTikTok={productVariant?.viral_on_tik_tok}
                    discountPercentage={discountPercentageToPass}
                    isOnlyAtAirshopDiscount={isOnlyAtAirshopDiscount}
                    showDeluxeBanner={showDeluxeBanner}
                    showPaidSingleUseBanner={showPaidSingleUseBanner}
                    wasJustDropped={wasJustDropped}
                    analyticEventPrefix={ANALYTIC_EVENT_PREFIX}
                    isMini={isMini}
                    isSetWithAllFullSize={productVariant?.badges_all_full_size}
                    isSetWithFullSizeAndMinis={productVariant?.badges_full_size_and_minis}
                    isSetWithMinis={productVariant?.badges_minis}
                    isTopGiftSet={productVariant?.badges_top_gift}
                    isEquinoxLoves={productVariant?.badges_equinox_loves}
                    isTopDeal={productVariant?.badges_top_deal}
                    isAllures2024TopPicks={productVariant?.badges_allures_2024_top_picks}
                    isBlackOwned={productVariant?.badges_black_owned}
                    isGiftSet={isGiftSetVariantUtil(productVariant)}
                  >
                    <QuickShopProductSidebarSquadApprovedBadge
                      productId={productId}
                    />
                  </ProductBadges>

                  <div className='pdp-product-rating-wrapper'>

                    {
                      hasLikes && (
                        <View className='like-and-sample-count-container'>
                          <QuickShopProductSidebarLikes
                            likedCount={likedCount}
                            superLikedCount={superLikedCount}
                            variantId={ratedSampleOrProductVariantId}
                            shouldShowEditRating={shouldShowEditRating}
                          />
                        </View>
                      )
                    }

                    {
                      shouldShowEditRating && (
                        <QuickShopProductSidebarEditRating
                          variantId={ratedSampleOrProductVariantId}
                          productId={productId}
                          isFromProductPage
                        />
                      )
                    }
                  </div>

                  {
                    !!productVariant?.review_info?.rating_count && (
                      <QuickShopProductSidebarReviewRating
                        productVariant={productVariant}
                        isFromProductPage
                      />
                    )
                  }

                  <div className='pdp-product-price-wrapper'>
                    {
                      !isGiftCard && (
                        <Span className='quick-shop-product-sidebar-price'>
                          <PriceAndDiscountPrice
                            price={price}
                            discountPrice={discountPrice}
                          />
                        </Span>
                      )
                    }
                  </div>

                  {
                    shouldShowDealTimer && (
                      <DealTimer
                        variantId={variantIdToShowTimer}
                      />
                    )
                  }

                  {
                    isGiftCard && (
                      <>
                        <GiftPageAddAGiftAmountPicker />
                        <P>
                          {GIFT_CARD_PRODUCT_DESCRIPTION}
                        </P>
                      </>
                    )
                  }

                  {
                    !isGiftCard &&
                    !sidebarData?.shouldHideColorSwatches && (
                      <QuickShopProductSidebarColorSwatches
                        productVariant={productVariant}
                      />
                    )
                  }

                  <div className='pdp-product-size-guide-wrapper'>
                    <QuickShopProductSidebarSizeGuide
                      productVariant={selectedProductVariant}
                      hasVariantButtons={hasVariantButtons}
                    />
                  </div>

                  {
                    hasVariantButtons && (
                      // !hideBothFullSizeAndSampleButtons && (
                      <div className='pdp-variant-buttons-wrapper'>
                        <VariantButtons
                          productVariants={productVariants}
                          quickShopHistory={quickShopHistory}
                        />
                      </div>
                    )
                  }

                  {
                    !!hasSubscriptions && (
                      <QuickShopProductSidebarDelivery
                        productVariant={selectedProductVariant}
                        discountPrice={discountPrice}
                      />
                    )
                  }

                  <div className='pdp-product-button-wrapper'>

                    <QuickShopProductSidebarButton
                      productVariant={productVariant}
                      isGiftCard={isGiftCard}
                      needsToBeRatedSample={needsToBeRatedSample}
                      shouldShowEditRating={shouldShowEditRating}
                      isFromProductPage
                    />

                  </div>

                  <ProductDeliveryStatus />

                  <FullSizeDiscountAlert
                    productVariant={selectedProductVariant}
                    isSample={isSample}
                  />

                  {
                    !!shortDescription && (
                      <QuickShopProductSidebarShortDescription
                        shortDescription={shortDescription}
                      />
                    )
                  }

                  {
                    !!hasInfluencerInfo && (
                      <QuickShopProductSidebarInfluencerCard
                        influencerInfo={influencerInfo}
                      />
                    )
                  }

                  <FlexColumn className='quick-shop-product-sidebar-accordions'>

                    {
                      howToUse && (
                        <QuickShopProductSidebarHowToUse
                          howToUse={howToUse}
                        />
                      )
                    }

                    {
                      ingredients && (
                        <QuickShopProductSidebarIngredients
                          ingredients={ingredients}
                        />
                      )
                    }

                  </FlexColumn>

                  {
                    !!hasUseItWithVariant && (
                      <div className='pdp-use-it-with-wrapper'>
                        <QuickShopProductSidebarUseItWith
                          perfectYourLookVariantId={perfectYourLookVariantId}
                          perfectYourLookVariantList={productVariant.pyl_variant_list}
                        />
                      </div>
                    )
                  }

                </div>
              </div>
              <FlexColumn className='pdp-product-description-page-wrapper'>
                <FlexColumn>

                  <FlexColumn className='pdp-product-highlights-wrapper'>

                    {
                      !!highlights && (
                        <Highlights
                          highlights={highlights}
                        />
                      )
                    }
                  </FlexColumn>

                  {
                    !!bodyHtml && (
                      <div className='pdp-product-about-this-item-wrapper'>
                        <QuickShopProductSidebarAboutThisItem
                          bodyHtml={bodyHtml}
                          aboutImageUrl={aboutImageUrl}
                        />
                      </div>
                    )
                  }

                  <div className='pdp-reviews'>
                    <Reviews
                      productId={productId}
                      productVariant={productVariant}
                    />
                  </div>

                  <CustomersAlsoBoughtSlider
                    wasJustDropped={wasJustDropped}
                    isSample={isSample}
                    isFullSize={isFullSize}
                    isJustDroppedSlider={!!sidebarData?.isJustDroppedSlider}
                    isGiftSetSlider={!!sidebarData?.isGiftSetSlider}
                    productVariant={productVariant}
                    isSampleTab={isSample}
                  />

                  <OtherItemsYourSquadLoved
                    productVariant={productVariant}
                  />
                  <FullSizeItemsYouVeSampled
                    productVariant={productVariant}
                  />

                  <DescriptionBenefits />

                </FlexColumn>
              </FlexColumn>
            </>
          </FlexColumn>
        )
      }

      <QuickShopLoadRatedVariant
        ratedVariantId={ratedVariantId}
      />

      <QuickShopProductSidebarSuggestInStockVariantOnMount
        isGiftCard={isGiftCard}
        setIsLoading={setIsLoading}
      />
    </FlexColumn>
  )
}
